<template>
  <el-form ref="form" :model="form" class="box-set" label-width="120px">

    <el-card header="基础信息" shadow="naver">
      <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
      <el-form-item label="活动banner" hide-requied-aterisk="true">

        <div @click="handleImgPicker" class="upload-box">
          <img v-if="form.banner" :src="form.banner" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
      </el-form-item>
        <el-form-item label="活动名称" prop="title">
          <el-col :span="20">
            <el-input v-model="form.name" :maxlength=80 placeholder="活动名称"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-col :span="20">
            <el-date-picker
              v-model="activity_date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="生效时间"
              end-placeholder="过期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
             >
            </el-date-picker>
          </el-col>
        </el-form-item>
      <el-form-item label="活动说明" prop="title">
        <el-col :span="20">
          <el-input v-model="form.activity_explain" :maxlength=200 placeholder="活动说明"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="每限领商品数量" prop="title">
        <el-col :span="20">
          <el-input-number v-model="form.limit_items_nums" type='number' placeholder="限领商品数"></el-input-number>
        </el-col>
      </el-form-item>
      <el-form-item label="是否限制总人数">
        <el-switch
                v-model="form.limit_user_type"
                active-color="#13ce66"
                inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
      <el-form-item label="活动总人数" prop="title">
        <el-col :span="20">
          <el-input-number v-model="form.limit_user_nums" type='number' placeholder="活动总人数"></el-input-number>
        </el-col>
      </el-form-item>
    </el-card>
    <el-card header="选择赠品" shadow="naver">
      <SkuSelector @change="getItems" :data="relItems" ></SkuSelector>
    </el-card>

    <!-- 指定门店 start -->
    <el-card header="店铺" shadow="naver">
      <el-form-item label="适用店铺">
        <el-radio-group v-model="form.use_all_shops_flag" @change="shopTypeChange">
          <el-radio label="true">全部适用</el-radio>
          <el-radio label="false">指定店铺适用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-button type="primary" @click="addDistributorAction">选择店铺</el-button>
      <el-table v-if="distributor_info.length > 0" :data="distributor_info" style="line-height: normal">
        <el-table-column label="ID" prop="distributor_id" width="60"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <i class="iconfont icon-trash-alt" @click="deleteDistritutorRow(scope.$index, form.items)"></i>
          </template>
        </el-table-column>
      </el-table>


    </el-card>

    <!--<el-card header="图文详情" shadow="never" v-loading="">-->
      <!--<template v-if="mode === 'richText'">-->
        <!--<vue-html5-editor :content="form.activity_detail" ref="editor" @change="updateContent" :height="360"></vue-html5-editor>-->
        <!--<span class="tpl_item img" @click="addImgPreview" style="">-->
            <!--<i class="iconfont icon-image"></i>图片-->
          <!--</span>-->
      <!--</template>-->
      <!--<imgPicker :dialog-visible="thumbDialog" :sc-status="isGetThumb" :isMost="true" @chooseImg="pickThumb" @closeImgDialog="closeThumbDialog"></imgPicker>-->
    <!--</el-card>-->
    <!-- 指定门店 end -->
    <!-- <StoreSelect :store-visible="storeVisible" :is-valid="true" :rel-data-ids="relStores" :get-status="setStatus" @chooseStore="chooseStoreAction" @closeStoreDialog="closeStoreDialogAction"></StoreSelect> -->
    <div class="content-center">
      <el-button @click.native="handleCancel">返回</el-button>
      <el-button  type="primary" @click="submitActivityAction()" >保存</el-button>

    </div>
    <!-- 指定门店 start -->
    <StoreSelect :store-visible="storeVisible" :is-valid="true" :rel-shop-ids="relShopIds" :get-status="setStatus" @chooseStore="chooseStoreAction" @closeStoreDialog="closeStoreDialogAction"></StoreSelect>
    <DistributorSelect :store-visible="distributorVisible" :is-valid="true" :rel-shop-ids="relDistributorIds" :get-status="setDistributorStatus" @chooseStore="chooseDistributorAction" @closeStoreDialog="closeDistributorDialogAction"></DistributorSelect>
    <!-- 指定门店 end -->
  </el-form>
</template>

<script>
import { updatebuyOnesFreeOnes,updateGiftsActivity,getGiftsActivity } from '../../../../api/promotions'

import SkuSelector from '@/components/function/skuSelector'
import imgPicker from '@/components/imageselect'
import store from '@/store'
// 指定门店 -- start --
import StoreSelect from '@/components/storeselect'
import DistributorSelect from '@/components/storeListSelect'
// 指定门店 -- end -
export default {
  inject: ['refresh'],
  components:{
    StoreSelect,
    SkuSelector,
    DistributorSelect,
    imgPicker,
  },
  data () {
    return {
      is_distributor: false,
      cursymbol: '￥',
      goodsVisible: false,
      community: '1',
      communityList: [],
      communitycount: 0,
      relItems: [],
      mainItems:[],
      addedItems: [],
      // 指定门店 -- start --
      distributorVisible: false, // 分销商可见，默认false
      setDistributorStatus: false,
      rel_shops_ids:[], // 指定适用门店ID集合
      distributor_info: [], // 指定适用门店信息集合
      relShopIds: '',
      relDistributorIds: '',
      zdShopHidden: true,
      setStatus: false,
      storeVisible: false,
      // 指定门店 -- end --
      communityParams: {
        page: 1,
        pageSize: 10,
        status: 'open'
      },
      copy_flag: false,
      form: {
        id: '',
        name: '',
        use_all_shops_flag: 'true',
        activity_explain:'',
        rel_items_ids: '',
        start_time: '',
        end_time: '',
        rel_rules_items: [],
        distributor_id: [],
        rel_shops_ids: []
      },
      activity_date: '',
      relItemsIds: [],
      selectItemType: 'normal',
      itemVisible: false,
      setItemStatus: false,
      imgDialog: false,
      isGetImage: false,
      relStores: [],
    }
  },
  methods:{
    closeStoreDialogAction () {
      this.storeVisible = false
    },
    chooseStoreAction (data) {
      this.storeVisible = false
      this.form.shop_ids = []
      if (data === null || data.length <= 0) return
      this.relStores = data
    },
    deleteStoreRow (index, ) {
      this.setStatus = false
      this.relStores.splice(index,1)
    },
    relStoresClick(){
      this.storeVisible = true
      this.setStatus = true
    },
    getItems(data) {
      let arr = []
      data.forEach((item, index) => {
        let newData = ''
        let isInArr = this.addedItems.findIndex((n) => n.item_id == item.itemId)
        if (isInArr == -1) {
          newData = {
            item_id: item.itemId,
            item_bn: item.itemBn,
            item_title: item.itemName,
            special_type: item.special_type,
            activity_price: item.activity_price ? item.activity_price : 0,
            market_price: item.market_price ? item.market_price : 0,
            img:item.pics[0]
          }
        } else {
          newData = this.addedItems[index]
        }
        arr.push(newData)
      })
      this.form.rel_rules_items = arr
    },
      handleImgPicker () {
          this.imgDialog = true
          this.isGetImage = true
      },
      pickImg (data) {
          this.form.banner = data.url
          this.imgDialog = false
      },
      closeImgDialog () {
          this.imgDialog = false
          this.isGetImage = false
      },

    getDetailAction(id){
        getGiftsActivity(id).then(res => {

            let response = res.data.data
            this.form.id = response.id
            this.form.name = response.name
            this.form.use_all_shops_flag = response.use_all_shops_flag
            this.form.banner = response.banner
            this.form.rel_items_ids = response.rel_items_ids
            this.form.start_time = response.start_time
            this.form.end_time = response.end_time
            this.form.activity_explain = response.activity_explain
            this.form.limit_user_nums = response.limit_user_nums
            this.form.limit_user_type = response.limit_user_type
            this.form.limit_items_nums = response.limit_items_nums
            this.form.rel_shops_ids = response.rel_shops_ids
            this.activity_date = [response.start_time_str, response.end_time_str]

            this.relItems = response.rules_item_tree || []
            this.form.rel_rules_items = response.rules_item

            this.distributor_info = response.distributor_info

            this.form.distributor_id = []
            for (var i in this.distributor_info) {
                if(this.form.distributor_id.indexOf(Number(this.distributor_info[i].distributor_id)) < 0) {
                    this.form.distributor_id.push(Number(this.distributor_info[i].distributor_id))
                }
            }
        })
    },

    communityChange(val){
      if (val == 1) {
        this.form.community = []
      }
    },
    deleteItemRow: function (index, rows) {
      rows.splice(index, 1)
      this.form.rel_rules_items = rows
      this.setItemStatus = false
      this.relItemsIds.splice(index, 1)
    },
    copyeItemRow: function (index,rows){
      console.log(rows)
        let newData = ''
        newData = {
            item_id: rows[index]['item_id'],
            item_bn: rows[index]['item_bn'],
            item_title: rows[index]['item_title'],
            activity_price: rows[index]['activity_price'],
            main_item_num:  rows[index]['main_item_num'],
            special_type: rows[index]['special_type'],
            item_type:  rows[index]['item_type'],
            market_price: row[index]['market_price'],
        }

       this.form.rel_rules_items.push(newData)
    },
    submitActivityAction () {
      const that = this
        if (this.activity_date.length > 0) {
            this.form.start_time =  this.dateStrToTimeStamp(this.activity_date[0])
            this.form.end_time = this.dateStrToTimeStamp(this.activity_date[1])
        }
      //
      if(this.form.rel_rules_items.length < 1){

          alert('请设置赠品');
          return false;
      }


        updateGiftsActivity(this.form).then(res => {
            if(res.data.data.id){
                this.loading = false
                this.$message({
                    message: '更新成功',
                    type: 'success',
                    duration: 2 * 1000,
                    onClose () {
                        that.refresh()
                        that.$router.go(-1)
                    }
                })
            } else {
                this.$message.error(res.data.message)
                return false
            }
        })
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    // 指定门店 -- start --
    shopTypeChange (val) {
        this.form.distributor_id = []
    },
    addDistributorAction () {
      this.distributorVisible = true
      this.setDistributorStatus = true
      this.relDistributorIds = this.form.distributor_id
    },
    chooseStoreAction (data) {
      this.storeVisible = false
      this.form.rel_shops_ids = []
      if (data === null || data.length <= 0) return
      this.rel_shops_ids = data
      for (var i = 0; i < data.length; i++) {
        if(this.form.rel_shops_ids.indexOf(data[i].wxShopId) < 0) {
          this.form.rel_shops_ids.push(Number(data[i].wxShopId))
        }
      }
    },
    chooseDistributorAction (data) {
      this.distributorVisible = false
      this.distributorVisible = false
      if (data === null || data.length <= 0) return
      this.distributor_info = data
      for (var i = 0; i < data.length; i++) {
        if(this.form.distributor_id.indexOf(Number(data[i].distributor_id)) < 0) {
          this.form.distributor_id.push(Number(data[i].distributor_id))
        }
      }
    },
    closeStoreDialogAction () {
      this.storeVisible = false
    },
    closeDistributorDialogAction () {
      this.distributorVisible = false
    },
    deleteDistritutorRow (index) {
      this.distributor_info.splice(index, 1)
      let shopDatas = this.distributor_info
      this.form.distributor_id = []; // 重新初始化 distributor_id 为空数组
      for (var i = 0; i < shopDatas.length; i++) {
        if(this.form.distributor_id.indexOf(Number(shopDatas[i].distributor_id)) < 0) {
          this.form.distributor_id.push(Number(shopDatas[i].distributor_id))
        }
      }
    },

    handleCancel: function () {
      this.$router.go(-1)
    }
  },
  mounted () {
    // if (store.getters.login_type === 'distributor') {
    //   this.is_distributor = true
    // }
    if (this.$route.params.id) {
        // alert(this.$route.params.id)
      this.getDetailAction(this.$route.params.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// add.vue?cb7ee36a